import React, { useContext} from 'react';
import { AssessmentContext } from '../context/AssessmentContext';
import { CountryContext } from '../context/CountryContext';
import { parseToHtml,draftJsToTipTap} from '../utils/parseToHTML';

const ExistingVisaResult = () => {
  const [assessmentState, assessmentDispatch] = useContext(AssessmentContext);
  // eslint-disable-next-line no-unused-vars
  const [countryState, countryDispatch] = useContext(CountryContext);

  const convertContent = (content) => {
    if (typeof content !== 'string') return null;

    const trimmedContent = content.trim();
    if (trimmedContent.startsWith('<')) return content;

    try {
      let contentState = JSON.parse(content);
      if (contentState && contentState.blocks) {
        contentState = draftJsToTipTap(contentState);
      }
      if (contentState && contentState.type === 'doc' && Array.isArray(contentState.content)) {
        return parseToHtml(contentState);
      }
      return content;
    } catch (e) {
      return content;
    }
  };

  const { subtext } = assessmentState.existingVisaResult;
  const subtextHtml = convertContent(subtext);


  const continueToAssessmentHandler = () => {
    assessmentDispatch({
      type: 'SET_EXISTING_VISA_DONE',
    });
  };

  const resetAssessment = () => {
    countryDispatch({ type: 'RESET_COUNTRIES' });
    assessmentDispatch({ type: 'RESET_ASSESSMENT' });
  };

  const functionPrint = () => {

    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const nonPrintableElements = document.getElementById('__nonPrintable__');

    if (isSafari) {
    nonPrintableElements.classList.add('__noPrintSafari__');
    window.print();
    nonPrintableElements.classList.remove('__noPrintSafari__');
    }
    else {
    nonPrintableElements.classList.add('__noPrint__');
    window.print();
    nonPrintableElements.classList.remove('__noPrint__');
    }
  };

  return (
    <div className='row' id='print_ex_page'>
       <div className='col-12 d-flex justify-content-end align-items-center mb-3'>
        {assessmentState.existingVisaResult.indicativeTime !== undefined && (
            <b>Indicative Immigration Lead Time: {
              assessmentState.existingVisaResult.indicativeTime === 1 ? '1 week' :
              `${assessmentState.existingVisaResult.indicativeTime} weeks`}
            </b>
        )}
      </div>
      <div className='col-12 d-flex justify-content-between align-items-center mb-3'>
        <span className='gw__existing-visa-header'>
          {assessmentState.existingVisaResult.title}
        </span>
        {assessmentState.existingVisaResult.icon}
      </div>

      <div className='col-12'>
        {subtextHtml !== null ? (
          <p
            className='gw__existing-visa-subtext'
            dangerouslySetInnerHTML={{ __html: subtextHtml }}
          />
        ) : (
          <p className='gw__existing-visa-subtext'>{subtext}</p>
        )}
      </div>

      <div className='col-12 d-flex justify-content-end mt-5 print_btn'>
        {assessmentState.existingVisaResult.isContinuingToAssessment ? (
          <button
            className='btn btn-primary'
            onClick={continueToAssessmentHandler}
          >
            NEXT
          </button>
        ) : (
          <>
            {//check if existing visa has eligible output and adds pdf download button
            (assessmentState.existingVisaResult.title === 'Candidate is Eligible' || !assessmentState.existingVisaResult.title.toLowerCase().endsWith('required') 
            ) && (
              <button className='btn btn-primary' onClick={functionPrint}>
                SAVE AS PDF
              </button>
            )}

            <hr />
            <button className='btn btn-primary' onClick={resetAssessment}>
              EXIT ASSESSMENT
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ExistingVisaResult;
